<template>
  <Spinner v-if="isLoading" />
    
  <Toast />
        <ConfirmDialog></ConfirmDialog>
        <ConfirmDialog group="templating">
                <template #message="slotProps">
                    <div class="flex p-4">
                        <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
                        <p class="pl-2">{{slotProps.message.message}}</p>
                    </div>
                </template>
        </ConfirmDialog>
        <ConfirmDialog group="positionDialog"></ConfirmDialog>  
  <div v-if="isAuthenticated" class="grid">

    <div class="card col-12 placenoKodovi" v-if="paid"> 
      <div class="grid codeForLaboratory">
        <div class="col-12 placenotextnaslov">PATRONAŽA PLAĆENA!</div>
        <div v-if="analysisCondition(analysisRequestId)" class="col-12 placenotext">Kodovi za laboratoriju</div>
        <div v-if="analysisCondition(analysisRequestId)" class="col-12 placenotext">
          <div class="codeUserLabel">Korisnik ID: </div>
          <div class="codeUser">{{ codeUser }}</div>
        </div>
        <div v-if="analysisCondition(analysisRequestId)" class="col-12 placenotext">
          <div class="codeAnalizalabel">Analiza ID: </div>
          <div class="codeAnaliza">{{ codeAnalysis }}</div>
        </div>
      </div>
    </div>

    
    <div class="card col-12 cancelTextSection" v-if="(!cancelButtonVisible(status) && !isCanceled(status))">
      <div class="grid codeForCancelationText">
      <div class="col-12 placenotext">Ako hoćete da otkažete patronažu, pozovite naš call centar na broj: <a href="tel:0113449750">011/ 344 97 50</a></div>        
    </div>
  

    </div>

    <div class="card col-12 mainTitle">
      <h3 class="stationsHeader">{{ translated('homevisitreview').toUpperCase() }}</h3>                
    </div>	
    <div class="homevisit-view-left card col-12 md:col-6">
      <div class="card col-12 mainTitle">
        <!-- <h3 class="stationsHeader">OSNOVNI PODACI</h3> -->
        <h3 class="stationsHeader">{{ translated('basicInfo').toUpperCase() }}</h3>
      </div> 
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('person') }} </label>
        </div>
        <div class="col-12 sm:col-7">
            <InputText disabled type="text" v-model="personFullName"/>
        </div>
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
            <label>{{ translated('address') }} </label>
        </div>
        <div class="col-12 sm:col-7">
            <InputText disabled type="text" v-model="address"/>
        </div>
      </div>                                                       
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
            <label>{{ translated('zip') }} </label>
        </div>
        <div class="col-3 sm:col-2">
            <InputNumber disabled type="text" v-model="zip" :useGrouping="false"/>
        </div>
        <div class="col-9 sm:col-5">
            <InputText disabled type="text" v-model="city"/>
        </div>
      </div>	
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('requestdate') }} </label>
        </div>   
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="requestDate"/>
        </div>                      
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('agreeddate') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="agreedDate"/>
        </div>                      
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('status') }} </label>  
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="statusName"/>
        </div>                       
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('clientnotes') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <textarea disabled type="text" v-model="clientNotes" class="clientnotecls"/>
        </div>
      </div>
      <div class="p-fluid grid elementGroup lastFieldElement">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('hvanalysisrequest') }} </label> 
        </div> 
        <div class="col-12 sm:col-7">
          <p v-if="analysisCondition(analysisRequestId)">
              <router-link  :to="{ name: 'AnalysisReview', params: { id: analysisRequestId}}"> 
                  {{analysisDisplay(analysisRequestId)}}
              </router-link>
          </p> 
          <p v-else>
              {{analysisDisplay(analysisRequestId)}}
          </p> 
        </div>                       
      </div>

      <div v-if="analysisCondition(analysisRequestId)" class="analysis-elements card col-12">
        <div class="card col-12 mainTitle">          
          <div class="analizatitle">
                      <!-- <h3 class="stationsHeader">ELEMENTI ANALIZE</h3> -->
            <h3 class="stationsHeader">{{ translated('analysisElements').toUpperCase() }}</h3>
            <!-- <Button class="submitbtn1" icon="pi pi-file-edit" :label="translated('editAnalysis')" @click="editAnalysis()"/> -->
            <Button v-if="!paid" class="submitbtn1" icon="pi pi-file-edit" @click="editAnalysis()"/>
            

          </div>
        </div>
        <DataTable class="selectedAnalysisTable" :value="analysisItemsForTable" stripedRows tableStyle="width: 100%">
          <Column field="name" :header="translated('nameing')">
            <template #body="slotProps">
              {{slotProps.data.name}}              
            </template>
          </Column>
          
          <Column field="price" :header="translated('price')">
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.price) }}
            </template>
          </Column>
        </DataTable>
        <div class="grid totalPriceFrame">
          <div class="col-6 priceTotalLabel">Iznos analiza</div>
          <div class="col-6 priceTotal">{{ formatCurrency(analysisTotalPrice) }}</div>
        </div>           
      </div>

      <div v-if="patronazaPriceDisplay(locationPriceId)">
        <div class="grid pricePatronaza">
          <div class="col-6 patronazaLabel">Cena patronaže</div>
          <div class="col-6 patronazaSum">{{ formatCurrency(locationPrice) }}</div>
          <div class="col-12 patronazaSmall">* {{ locationPriceText }}</div>
        </div>     
      </div>

      <div v-if="displayTotalPrice()"> 
        <div class="grid priceTotalTotal">
          <div class="col-6 totalLabel">UKUPNO</div>
          <div class="col-6 totalSum">{{ formatCurrency((analysisTotalPrice + locationPrice)) }}</div>

          <div class="col-12 paymentSection" v-if="!cancelButtonVisible(status) && !paid">
            <router-link :to="{ name: 'Pay', params: { id: homevisit.id, amount: (analysisTotalPrice + locationPrice), otype: 'H' }}">
              <Button :label="translated('pay')" icon="pi pi-money-bill" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue buttonPay" />  
            </router-link>
          </div>
        </div>   
      </div>      
      
      <div v-if="cancelButtonVisible(status)" class="buttonsRight">        
        <Button class="submitbtn1" icon="pi pi-times-circle" :label="translated('cancel')" @click="confirm()"/>
      </div>

    </div>
    <div class="homevisit-view-right card col-12 md:col-6">
      <div class="card mainTitle">      

        <div class="flex">
          <div class="mainTitleHElement w-10">
            <!-- <h3 class="parent-messages-header">PORUKE</h3> -->
            <h3 class="parent-messages-header">{{ translated('messages').toUpperCase() }}</h3>
          </div>
          <div v-if="cancelButtonVisible(status)" class="mainTitleButton w-2">
            <Button id="new-message" class="p-button p-button-icon-only p-button-raised p-button-rounded" icon="pi pi-plus" @click="displayModalText=true"/>
          </div>                

        </div>

      </div>

      <div class="messageslist card">
        <div v-for="x in messagesList" :key="x" :class="[useOperatormessageclass(x.messageType)? 'operatormessageslist card' : 'clientmessageslist card']">
          <div class="p-fluid grid message-header">
            <div class="col-6 message-date">{{ formatMessageDate(x.messageDate) }}</div>
            <div class="col-6 message-person" v-if="x.messageType">{{ x.operator.nameSurname }}</div>
            <div class="col-6 message-person" v-else>{{ x.person.name + " " + x.person.surname}}</div> 
          </div> 
            {{ x.message }}  
          <li>
            <Button v-if="cancelButtonVisible(status) && x.messageType == 1 && x.responded == 0 && x.suggestedDate != null"  icon="pi pi-check" class="p-button-rounded messagereplybtn" aria-label="Filter" :title ="translated('accept')" @click="handleAcceptDate(x.id)" autofocus  />
            <Button v-if="cancelButtonVisible(status) && x.messageType == 1 && x.responded == 0 && x.suggestedDate != null"  icon="pi pi-clock" class="p-button-rounded messagereplybtn" aria-label="Filter" :title = "translated('suggestNewDate')" @click="handleNewHomeVisitTimeDate(x.id)" />
            <!-- class="messagereplybtn" -->
          </li> 
        </div>
      </div>
    </div>  
  </div>
  
  <div v-else class="col-12">
      <h1>{{ translated('noAccessRights').toUpperCase() }}</h1>
  </div>
  
  <Dialog class="modal-text grid"  :header="translated('sendMessage').toUpperCase()"  v-model:visible="displayModalText" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}" :modal="true">
    <div class="new-message col-12">
      <textarea name="messagetext" class="messagetext col-12" id="messagetext" :autoResize="true" rows="10" wrap="soft" :placeholder="translated('enterMessage')" v-model="messageText" ></textarea>
    </div>
    <template #footer>
      <!-- <div class="grid"> -->
        <!-- <div class="p-fluid grid elementGroup col-12"> rows="10" cols="52"-->
          <!-- <div class="modal-buttons col-offset-3"> -->
          <div class="modal-buttons">
            <Button :label="translated('sendMessage')" icon="pi pi-check" @click="handleInsertCustomTextMessage" class="submitbtn" />
            <Button :label="translated('goBack')" icon="pi pi-times" @click="displayModalText=false" autofocus class="submitbtn" />
          </div>
        <!-- </div> -->
      <!-- </div> -->
    </template>
  </Dialog>
  <Dialog class="modal-time grid" :header="translated('chooseDesiredDateTime').toUpperCase()" v-model:visible="displayModalTime" :breakpoints="{'1100px': '60vw', '640px': '100vw'}" :style="{width: '30vw'}" :modal="true">
    <div class="p-fluid grid elementGroup">
      <div class="date col-12">
        <label for="timeFrom">{{ translated('homeVisitDate') }}</label>
        <Calendar class="hvdate" inputId="icon" v-model="selectedDate" :showIcon="true" dateFormat="dd-mm-yy" :minDate="new Date()"/>
      </div>
    </div>
    <div class="p-fluid grid elementGroup">
      <div class="time-from col-12">
        <!-- <vue-timepicker label="Vreme od" format="HH:mm" :hour-range="[[8, 20]]" :minute-interval="15" v-model="timeFrom"></vue-timepicker> rows="10" cols="52"-->
        <label for="timeFrom">{{ translated('timeFrom') }}</label>
          <!-- <Calendar class="hvtime-from" inputId="timeFrom" v-model="timeFrom" :showTime="true" :timeOnly="true" :hourFormat=24 />  -->
          <TimePickerBiomedica class="timecontrolFrom" :homeVisitDate = "homeVisitDate" :timeStartInt="computedFrom" @timeChanged="startChanged"/>
      </div>
    </div>
    <div class="p-fluid grid elementGroup">
      <div class="time-till col-12">
        <!-- <vue-timepicker label="Vreme do" format="HH:mm" :hour-range="[[8, 20]]" :minute-interval="15" v-model="timeTill"></vue-timepicker> -->
        <label for="timeTill">{{ translated('timeTill') }}</label>
        <!-- <Calendar class="hvtime-till" inputId="timeTill" v-model="timeTill" :showTime="true" :timeOnly="true" :hourFormat=24 prevMinute="00"/> -->
        <TimePickerBiomedica class="timecontrolTill" :homeVisitDate = "homeVisitDate" :timeStartInt="computedTill" @timeChanged="tillChanged"/> 
      </div>
    </div> 
    <template #footer>
      <div class="modal-buttons">
        <Button label="Posalji termin" icon="pi pi-check" @click="handleInsertNewHomeVisitDateMessage" class="submitbtn" />
        <Button label="Odustani" icon="pi pi-times" @click="displayModalTime=false" autofocus class="submitbtn" />
      </div>
    </template>
  </Dialog>
  <Dialog v-model:visible="acceptedHomeVisit" modal :header="translated('acceptedHomeVisit').toUpperCase()" :style="{ width: '50vw' }" :breakpoints="{ '960px': '75vw', '641px': '100vw' }">
    <p>Poštovani,</p>
    <p>Drago nam je da ste prihvatili predloženi termin patronaže. Nakon potvrde operatera, dobićete e-mail sa potvrdom termina
      i moći ćete izabrati način plaćanja.</p>
    <p>Vaš BioMedica tim</p>
    <template #footer>
        <Button :label="translated('backtomainscreen')" icon="pi pi-check" @click="closeAcceptanceModal()" autofocus />
    </template>
</Dialog>
</template>
        

<script>
import createHttp from "@/services/http";
import router from "@/router/index";
import { computed } from "vue"
import store from "@/store";
import Spinner from "@/components/Spinner.vue";
import Calendar from 'primevue/calendar';
import ConfirmDialog from 'primevue/confirmdialog';
import VueTimePicker from "vue3-timepicker";
import "vue3-timepicker/dist/VueTimepicker.css";
import TimePickerBiomedica from '@/components/TimePickerBiomedica.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';


export default {
components: { Spinner, 
              Calendar, 
              "vue-timepicker": VueTimePicker,
              ConfirmDialog,
              TimePickerBiomedica,
              DataTable,
              Column
            },
props: ['id'],
computed: {
  computedFrom (){
            this.timeFrom =this.initFrom;
            return this.initFrom;
  },
  computedTill (){
      this.timeTill = this.initTill;
      return this.initTill;
  },
},
data() {
  return {
      homevisit:null,
      translated: computed(() => store.getters.getTranslate),
      personFullName:null,
      clientNotes: null,
      agreedDate: null,
      status: null,
      statusName: null,
      requestDate: null,
      analysisRequestId: null,
      analysis: null,
      displayModalButtons: false,
      displayModalText:false,
      displayModalTime:false,
      selectedDate:'',
      homeVisitDate: '',
      timeFrom:'',
      timeTill:'',
      homevisitid:null,
      messageText:'',
      suggestedDate: null,
      suggestedTimeFrom: 0,
      suggestedTimeTill: 0,
      suggestedDateAgreedDisagreed: null,
      agreed: false,
      disagreed: false,
      responded: false,
      messageRead: false,
      messageReadDate: null,
      operatorId: null,
      operator: null,
      messageType: '',
      messagesList:[],
      isLoading: false,
      address: null,
      zip: null,
      city: null,
      initHour: 8,
      initFrom: null,
      initTill: null,
      messageIdForReplyingOnNewHomeVisitDate: null,
      analysisItemsForTable: [],
      analysisTotalPrice: null,
      acceptedHomeVisit: false,
      locationPrice: null,
      locationPriceText: null,
      locationPriceId: null,
      locationPrices: [],
      paid: null,
      codeUser: null,
      codeAnalysis: null
    }
},
async created() {
  
  debugger;
  this.homeVisitDate = new Date(this.selectedDate);
  this.initFrom=60;
  this.initTill=90;
  
  this.isLoading = true;
  const http = createHttp(true);

  // Preberem cene ki so mogoče za patronažo
  const resultLocationsPrices = await http.get(process.env.VUE_APP_API_FOLDER + "/GetLocationPrices");
  this.locationPrices = resultLocationsPrices.data;

  // console.log(this.id +"////////////////////////////////////////////////////////////////////////////////////////////"); 
  const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetHomeVisitWithMessages" + "?id=" + this.id);

    if(result.status==200){
      this.homevisit = result.data;
      this.personFullName = this.homevisit.person.name + ' ' + this.homevisit.person.surname;
      this.clientNotes = this.homevisit.clientNotes;
      this.status = this.homevisit.status;
      this.statusName = this.translated('status_' + this.homevisit.status);
      this.agreedDate = this.formatDate(this.homevisit.agreedDate);
      this.analysisRequestId = this.homevisit.analysisRequestId;
      this.requestDate = this.formatDate(this.homevisit.requestedDate);
      this.messagesList = this.homevisit.messages;
      this.address = this.homevisit.person.address;
      this.zip = this.homevisit.person.zip;
      this.city = this.homevisit.person.city;
      this.timeFrom = this.homevisit.timeFrom;
      this.timeTill = this.homevisit.timeTill;

      this.paid = this.homevisit.paid;

      if(this.homevisit.locationPriceId != null){
          this.locationPriceId = this.homevisit.locationPriceId;
          this.locationPrice = this.locationPrices.find(x => x.id == this.homevisit.locationPriceId).price;    
          this.locationPriceText = this.locationPrices.find(x => x.id == this.homevisit.locationPriceId).title;    
      }
 
      // Sedaj naložim še vse analize, da jih lahko prikažem
      debugger;
      if(this.isValidGuid(this.analysisRequestId) && !this.isEmptyGuid(this.analysisRequestId)) {
        const resultAnalysis = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAnalysisRequest" + "?id=" + this.analysisRequestId);
        if(resultAnalysis.status==200) {
          this.analysis = resultAnalysis.data;
          this.analysisItemsForTable = this.analysis.analysisItems;
          this.analysisTotalPrice = this.analysis.totalPrice;

          this.codeUser = this.analysis.codeUser;
          this.codeAnalysis = this.analysis.codeAnalysis;

          // console.log(this.analysis);
          // console.log(this.analysisItemsForTable);
        }  
      }
    

    }
    this.isLoading = false; 
  // console.log(this.status)
},
async mounted(){
    this.initTill=180; 
    this.initFrom=45;
},
methods: {
  async GetMessages() {
    
    const http = createHttp(true);
    const resultMessages = await http.get(process.env.VUE_APP_API_FOLDER + "/GetHomeVisitMessages" + "?id=" + this.id);
        if(resultMessages.status==200) {
          this.messagesList = resultMessages.data;
        }  
  },

  editAnalysis(){
    if(this.isValidGuid(this.analysisRequestId) && !this.isEmptyGuid(this.analysisRequestId)) {
      router.push({ name: 'NewAnalysis', params: { id: this.analysisRequestId, homevisitid: this.id, source:'homevisit', linked: true  } });
    }       
  },
  isAuthenticated() {
    return store.getters.isAuthenticated;
  },
  isValidGuid(guid) {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    return guidRegex.test(guid) && guid !== emptyGuid;
  },      
  isEmptyGuid(guid) {
    return '00000000-0000-0000-0000-000000000000' == guid;
  },     
  formatMessageDate(value) {
    if(value != null){
      let myDate = new Date(value);

      return  myDate.toLocaleDateString('ro-Ro') + " " + myDate.toLocaleTimeString('ro-RO',{ hour: "2-digit", minute: "2-digit" });
    }
  },
  startChanged(data, timeInt) {
      this.timeFrom = timeInt;

      if(this.timeFrom >= this.timeTill) {
          this.initTill = this.timeFrom + 15;
      }
  },
  tillChanged(data, timeInt) {
      this.timeTill = timeInt;

      if(this.timeTill <= this.timeFrom) {
          this.initFrom = this.timeTill - 15;
      }
  },
  formatDate(value) {
    if(value != null){
      let myDate = new Date(value);

      return myDate.toLocaleDateString('ro-Ro');
    }
  },
  formatCurrency(amount){
    debugger;
    if(amount != null){
      const formattedAmount = amount.toLocaleString('rs-RS', {
        style: 'currency',
        currency: 'RSD',
      });
      return formattedAmount.replace(/(^\D*)([\d,.]*)(\D*$)/, "$2 $1").trim();
    }
      
      // return formattedAmount.replace(/(^\D*)(\d.*\d)(\D*$)/, '$2 $1').trim();
  },
  patronazaPriceDisplay(value){
      return (value != null && value > 0);
  },
  displayTotalPrice(){
    const hasPatronazaPrice = this.locationPriceId != null && this.locationPriceId > 0;
    const hasAnalysisPrice = this.analysisTotalPrice != null && this.analysisTotalPrice > 0;
    return hasPatronazaPrice || hasAnalysisPrice;
  },  
  analysisDisplay(value){
      if(value === "00000000-0000-0000-0000-000000000000" || value === null || !value){
        return this.translated('no');//VUCI IZ TRANSLATEA!!!!!
      } else {
          return this.translated('yes');
      }
  },
  analysisCondition(value){
      if(value === "00000000-0000-0000-0000-000000000000" || value === null || !value){
          return false;
      } else {
          return true;
      }
  },
  useOperatormessageclass(value){
      if(value === 1){
          return true;
      } else {
          return false;
      }
  },
  cancelButtonVisible(value){
    if("Requested".localeCompare(value) || value === "Communication".localeCompare(value))
    {
      return false;
    }
    else
    {
      return true;
    }
  },
  isCanceled(value){
    if(value == null)
    {
      return false;
    }
    
    return "Canceled".toLowerCase().localeCompare(value.toLowerCase()) == 0;
  },
  formatTime(value){
      let hour = Math.floor(value / 60).toString().padStart(2, '0');
      let minute = (value % 60).toString().padStart(2, '0');
      return hour + ":" + minute;
  },
  getHours(value){
    // console.log(value + "getHours------------------------------------------------------------------")
    let hourminute =  value.split(':');
    return  parseInt(hourminute[0]);
  },
  getMinutes(value){
    // console.log(value + "getMinutes------------------------------------------------------------------")
    let hourminute =  value.split(':');
    return  parseInt(hourminute[1]);
  },
  confirm(event) {
    this.$confirm.require({
        message: this.translated('wantCancelHomeVisit'),
        header: this.translated('confirmation'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            // await this.hand
            this.isLoading = true;
            this.cancelHomeVisit();
            // this.$toast.add({severity:'info', summary:'Potvrđeno', detail:'Sačuvali ste izmene', life: 3000});
        },
        reject: () => {
            this.$toast.add({severity:'error', summary:this.translated('declined'), detail:this.translated('youDidNotCancelHomeVisit'), life: 3000});
        }
    });
  },
  async cancelHomeVisit(){
    this.isLoading = true;
    this.Errors = [];
    
    let homeVisitForCancellation = {
      homevisitid: this.homevisit.id
    }

    const http = createHttp(true);

    try {
          http.post(process.env.VUE_APP_API_FOLDER + "/cancelHomeVisit?id=" + this.homevisit.id)
              .then((response) => { 
                  // console.log('OK response');
                  // console.log(response);
                  this.isLoading = true;
                  this.$toast.add({severity:'info', summary:this.translated('confirmation'), detail:this.translated('sucessfulCancelingHomeVisit'), life: 2000});

                        // console.log('TAST MESSAGE PRE TOGA');
                        // console.log('OK response');
                        // console.log(response);
                        setTimeout(() => {
                          this.isLoading = false;
                           router.push("/");
                        }, 3000);
              })
              .catch((error) => {
                  const myErr = {...error};

                  // console.log('ERROR');
                  // console.log(myErr) 
                  this.Errors = myErr.response.data.Errors;
                  
                  
          })
      } 
      catch (error) {
          // console.log(error);
      }
    this.isLoading = false;
  },
  handleNewHomeVisitTimeDate(messageId) {
    this.isLoading = true;
    debugger;
    this.displayModalTime=true;
    this.selectedDate = this.formatDateQalendar(this.requestDate);
    this.initFrom = this.timeFrom;
    this.initTill = this.timeTill;
    this.isLoading = false;
    this.messageIdForReplyingOnNewHomeVisitDate = messageId;
  },
  async handleInsertNewHomeVisitDateMessage() {
    debugger;
    //this.isLoading = true;
    this.Errors = [];
    // console.log('klicem insert')

      let insertNewHomeVisitDateMessage = {
          homevisitid:this.homevisit.id,
          personid:this.homevisit.personId,
          message:"Poštovani, da li je moguće zakazati patronažu " + this.formatDateForMessage(this.selectedDate) + " u periodu od " + this.formatTime(this.timeFrom) + " do " + this.formatTime(this.timeTill) + "?",
          messageDate: new Date(),
          suggestedDate: this.makeDate(this.selectedDate),
          suggestedTimeFrom: this.timeFrom,
          suggestedTimeTill: this.timeTill,
          suggestedDateAgreedDisagreed: null,
          agreed: false,
          disagreed: false,
          responded: false,
          messageRead: false,
          messageReadDate: null,
          operatorId: null,
          messageType: 0
      }
      // console.log(insertNewHomeVisitDateMessage)
      const http = createHttp(true); 
      try {
          http.post(process.env.VUE_APP_API_FOLDER + "/insertNewHomeVisitDateMessage", insertNewHomeVisitDateMessage)
              .then((response) => { 
                  // console.log('OK response');
                  // console.log(response);
                  http.post(process.env.VUE_APP_API_FOLDER + "/SetMessageAsReadAndDisagreed?messageId=" + this.messageIdForReplyingOnNewHomeVisitDate)
                  this.messageIdForReplyingOnNewHomeVisitDate = null;
                  
                  this.$toast.add({severity:'info', summary:this.translated('confirmation'), detail:this.translated('sucessfulSentNewHomeVisitTime'), life: 3000});
                  // setTimeout(() => {
                  //     this.isLoading = false;
                  //     router.push("/");
                  // }, 2500);
                  //router.push("/");

                  // Potrebno je naložiti novea sporočila
                  this.GetMessages();
                  //this.isLoading = false;
              })
              .catch((error) => {
                  this.messageIdForReplyingOnNewHomeVisitDate = null;
                  const myErr = {...error};

                  // console.log('ERROR');
                  // console.log(myErr) 
                  this.Errors = myErr.response.data.Errors;
                  
                  
          })
      } 
      catch (error) {
          // console.log(error);
      }
    this.isLoading = false;
  },
  async handleInsertCustomTextMessage() {

    this.isLoading = true;
    this.Errors = [];
    // console.log('klicem insert')

      let insertCustomHomeVisitMessage = {
          //id:this.uguid,  
          homevisitid:this.homevisit.id,
          personid:this.homevisit.personId,
          //person: null,
          message:this.messageText,
          messageDate: new Date(),
          suggestedDate: null,
          suggestedTimeFrom: 0,
          suggestedTimeTill: 0,
          suggestedDateAgreedDisagreed: null,
          agreed: false,
          disagreed: false,
          responded: false,
          messageRead: false,
          messageReadDate: null,
          operatorId: null,
          //operator: null,
          messageType: 0
      }
      const http = createHttp(true); 
      try {
          //// console.log(process.env.VUE_APP_API_FOLDER + "/updatePerson"?uGuid=" + this.uguid)
          //http.post(process.env.VUE_APP_API_FOLDER + "/updatePerson?uGuid=" + this.uguid, UpdateUser)
          http.post(process.env.VUE_APP_API_FOLDER + "/insertCustomHomeVisitMessage", insertCustomHomeVisitMessage)
              .then((response) => { 
                  // console.log('OK response');
                  // console.log(response);                  
                  this.$toast.add({severity:'info', summary:'Potvda', detail:'Uspešno ste poslali novu poruku', life: 3000});
                  // setTimeout(() => {
                  //     this.isLoading = false;
                  //     router.push("/");
                  // }, 2500);
                  // router.push("/");
                  // Sedaj bi moral prebrati vsa sporočila in jih prikazati.
                  this.GetMessages();
                  this.isLoading = false;
                  this.displayModalText = false;
              })
              .catch((error) => {
                  const myErr = {...error};

                  // console.log('ERROR');
                  // console.log(myErr) 
                  this.Errors = myErr.response.data.Errors;
                  
                  
          })
      } 
      catch (error) {
          // console.log(error);
      }
      this.isLoading = false;
      this.displayModalText = false;
    },
    async handleAcceptDate(messageId) {
      debugger;
      //TODO: TREBA NEKAKO NAPRAVITI OVU FUNKCIJU DA ODRADI OVO, IZBACI MODAL U KOM PISE DA JE POTREBNO I DA POTVRDI OPERATER, I DA SE POSALJE NOVI TEXT MESSAGE U KOM CE PISATI DA JE TERMIN PRIHVACEN. 
      //SA OPERATERSKE STRANE NEKAKO ODRADITI ILI NESTO SLICNO DA BUDE SAMO STIKLIRANJE MOGUCE
      //this.$router.push('/');
      //setTimeout(() => this.$router.push({ name: 'Dashboard' }), 1500);
      this.isLoading = true;
      this.acceptedDate = true;

      this.Errors = [];
      // console.log('klicem accept')

      // let acceptOfferedHomeVisitTime = {
      //   //id: this.homevisit.message.id,  
      //   homevisitid: this.id
      // } ZA SADA NEPOTREBNO
      const http = createHttp(true); 
      try {
          http.post(process.env.VUE_APP_API_FOLDER + "/acceptOfferedHomeVisitTime?id=" + this.id)
              .then((response) => { 
                  // console.log('OK response');
                  // console.log(response);
                  //router.push("/");
                  this.isLoading = false;
                  this.insertAcceptDateMessage(messageId);
              })
              .catch((error) => {
                  const myErr = {...error};

                  // console.log('ERROR');
                  // console.log(myErr) 
                  this.Errors = myErr.response.data.Errors;
                  
                  
          })
      } 
      catch (error) {
          // console.log(error);
      }
      this.isLoading = false;
    },
    formatDateQalendar(value) {
        // console.log(value);
            if(value != null){
              debugger;
                const [day, month, year] = value.split(".");
                const formattedDate = `${day}-${month}-${year}`;

                return formattedDate;
            }
    },
    formatDateForMessage(value) {
        // console.log(value);
            if(value != null){
              debugger;
              const [day, month, year] = value.split("-");
              const formattedDate = `${day}.${month}.${year}`;

                return formattedDate;
            }
    },
    makeDate(value) {
      debugger;
      const gmtOffsetMs = 2 * 60 * 60 * 1000;
      const parts = value.split("-");
      const year = parseInt(parts[2]);
      const month = parseInt(parts[1]) - 1;
      const day = parseInt(parts[0]);

      const timeValue = Date.UTC(year, month, day, 0, 0, 0) + gmtOffsetMs;
      const madeDate = new Date(timeValue);
      // console.log(madeDate);
      return madeDate ;
    },
    async insertAcceptDateMessage(messageId) {
      debugger;
      this.isLoading = true;
      this.Errors = [];
      // console.log('klicem insert');

      let insertCustomHomeVisitMessage = {
          homevisitid:this.homevisit.id,
          personid:this.homevisit.personId,
          message:"Poštovani, saglasan sam sa predloženim terminom patronaže.",
          messageDate: new Date(),
          suggestedDate: this.homeVisitDate,
          suggestedTimeFrom: this.timeFrom,
          suggestedTimeTill: this.timeTill,
          suggestedDateAgreedDisagreed: this.homeVisitDate,
          agreed: true,
          disagreed: false,
          responded: false,
          messageRead: false,
          messageReadDate: null,
          operatorId: null,
          messageType: 0
      }
      const http = createHttp(true); 
      try {
          http.post(process.env.VUE_APP_API_FOLDER + "/insertCustomHomeVisitMessage", insertCustomHomeVisitMessage)
              .then((response) => { 
                  // console.log('OK response');
                  // console.log(response);
                  this.isLoading = false;
                  this.acceptedHomeVisit = true;
              })
              .catch((error) => {
                  const myErr = {...error};

                  // console.log('ERROR');
                  // console.log(myErr) 
                  this.Errors = myErr.response.data.Errors;
                  
                  
          })
      } 
      catch (error) {
          // console.log(error);
      }
      this.isLoading = false;
    },
    closeAcceptanceModal(){
      this.acceptedHomeVisit = false;
      router.push("/");
    }
  }
}
</script>

<style scoped>
.labeldiv { padding-bottom:0px}
.elementGroup { margin-bottom: 10px}
.datetimeinfo{
  display: flex;
  justify-content: center;
}

/*
.parent-messages-header, .message-header{
  display: flex;
}
*/
.messages{
  left: 0;
  font-size: larger;
  justify-content:space-evenly;
} 
.message-date{
  left: 0;
  justify-content:space-evenly;
  padding-top: 0;
  font-weight: bold;
} 
.new-message-button{
  right: 0;
  margin-left: 74%;
}
.message-person{
  right: 0;
  padding-top: 0;
  font-weight: bold;
}
.clientmessageslist{
  /*width: 100%;*/
  /*padding-right: 10%;*/
  margin-left:50px;
  list-style: none;
  /*border: solid 5px #90EE90;*/
  box-shadow: 1px 1px 4px 1px #888888;  
}
.operatormessageslist{
  margin-right: 50px;
  list-style: none;
  /*border: solid 5px #fc4e59;*/
  box-shadow: 1px 1px 4px 1px #888888;
  background: rgb(250, 234, 234);
} 
.modal-buttons{
  text-align: center;
  display: flex;
  justify-content: center;
  
} 
/* .modal-buttons-modal{
  display: flex;
  text-align: center;
  justify-content: center;
} */
/* #messagetext{
  height: 50px;
  width: 80%;
  margin-left: 10%;

} */
.messagereplybtn{
  /* width:35px; */
  /* height: 20px; */
  margin-right: 5%;
  /*top: 140px;*/
  /*left: 0;*/
}
#new-message{
  height: 2.1rem;  
}

/* .modal-buttons{
  display: flex;
  justify-content: center;
} */

.operatormessageslist.card li {
    margin-top: 10px;
    margin-bottom: 10px;
}

.aktivneukupne span {
    width: 60px;
    height: 40px;
    background: #6c757d45;
    display: block;
    padding: 5px;
    border-radius: 7px;
    text-align: center;
    cursor: pointer;
    color: #6c757dc4;
}
.messagetext{
  box-shadow: 1px 1px 4px 1px #888888; 
}
.modal-text{ box-shadow: 1px 1px 4px 1px #888888; }

#new-message { float: right; }
/deep/ .p-datatable .p-datatable-tbody > tr > td:nth-child(2)  { text-align:right; }

/deep/ .p-datatable .p-datatable-thead > tr > th:nth-child(2) div {    
    float:right;
    position:relative;
    display:block;
}

.priceTotal {
    text-align: right;
    font-weight: bold;
    font-size: 1.3em;
    padding-right: 20px;
}

.grid.totalPriceFrame {
    margin-top: 10px;
    border-top: solid 2px darkgrey;
}
.buttonsRight {
  display: flex;
  justify-content: center;
}

.submitbtn1{
  margin: 5px;
}

button.p-dialog-header-icon.p-dialog-header-close.p-link {display: none !important; }

@media (max-width: 600px) {
  .buttonsRight {
    align-items: center;
    margin-left: 49px;
    margin-right: 49px;
  }
}
@media (max-width: 400px) {
  .buttonsRight {
    flex-direction: column;
    align-items: center;
    margin-right: 5px;
    margin-left: 0px;
  }
}
 /*@media screen and (max-width: 501px) 
{ 
  .modal-text { width:8px;}
} */
/*[data-title]:hover:after { POKUSAO S OVIM ALI NIJE MI ISLO, VIDI SA GORAZDOM KAKO DA STILIZUJEMO TITLE
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
}
[data-title]:after {
    content: attr(data-title);
    background-color: rgb(219,219,219);
    color: #111;
    font-size: 150%;
    position: absolute;
    padding: 1px 5px 2px 5px;
    bottom: -1.6em;
    left: 100%;
    white-space: nowrap;
    box-shadow: 1px 1px 3px #222222;
    opacity: 0;
    border: 1px solid #111111;
    z-index: 99999;
    visibility: hidden;
}
[data-title] {
    position: relative;
}*/


.analizatitle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}


.priceTotalLabel {
    padding-left: 20px;
    font-weight: bold;
    font-size: 1.3em;
}

.grid.pricePatronaza {
    font-weight: bold;
    font-size: 1.3em;
}

.grid.priceTotalTotal {
    font-weight: bold;
    font-size: 1.5em;
    color: #a56363;
}

.priceTotalLabel {    
    font-weight: bold;
    font-size: 1.3em;
}

.grid.pricePatronaza {
    font-weight: bold;
    font-size: 1.3em;
}

.grid.priceTotalTotal {
    font-weight: bold;
    font-size: 1.5em;
    color: #a56363;
}

.patronazaLabel {
    padding-left: 35px;
}

.totalLabel {
    padding-left: 20px;
}

.patronazaSum {
    text-align: right;
    padding-right: 35px
}

.totalSum {
    text-align: right;
    padding-right: 20px
}

.analysis-elements.card {
    padding-bottom: initial;
    margin-bottom: initial;
}

.grid.priceTotalTotal {
    margin-top: 10px;
    margin-right: 10px;
    margin-left: 10px;
    border-top: solid 2px #a56363;
}

.patronazaSmall {
    font-size: 0.7em;
    font-weight: lighter;
    margin-left: 30px;
    padding-top: initial;
    margin-top: initial;
}

.grid.elementGroup.lastFieldElement {
    margin-bottom: 50px;
}

.paymentSection {text-align:right;padding-right: 20px;padding-top: 20px;}


.placenoKodovi { margin-top: 20px; }
.codeUserLabel, .codeAnalizalabel {position:relative; float:left;}
.codeAnaliza, .codeUser {position:relative; float:left; padding-left:10px; font-weight:bold; text-decoration:underline;    text-decoration-color: red; text-decoration-style: double; }
.codeForLaboratory { font-size:1.5em;}
.placenotextnaslov {background-color:red; color:white; font-size:1.8em; font-weight:bold;border-radius:5px;}
.cancelTextSection {margin-top:20px; font-size:1.3em;}
.cancelTextSection a {font-weight:bold; padding-left:10px; font-size:1.5em;}
.clientnotecls {resize: none; width: 100%; height: 120px; background: white; border: 1px solid #e2e5e9; padding: 7px; color: #92969a;}
</style>
